import { addReCaptchaScript, generateNonce } from "@/utils/util";
import { UI_CONFIGS } from "@/utils/const";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      grecaptcha: null,
    };
  },
  computed: {
    ...mapGetters({
      autoloadConfigValue: "config/getAutoloadConfigValue",
    }),
    recaptchaEnabled() {
      return this.autoloadConfigValue(UI_CONFIGS.RECAPTCHA_ENABLED) === "true";
    },
  },
  async mounted() {
    if (this.recaptchaEnabled) {
      this.grecaptcha = await addReCaptchaScript(
        this.autoloadConfigValue(UI_CONFIGS.RECAPTCHA_SITE_KEY)
      );
    }
  },
  watch: {
    async recaptchaEnabled(newVal) {
      if (newVal) {
        this.grecaptcha = await addReCaptchaScript(
          this.autoloadConfigValue(UI_CONFIGS.RECAPTCHA_SITE_KEY)
        );
      }
    },
  },
  methods: {
    async executeRecaptcha() {
      let recaptchaToken = null;
      if (this.recaptchaEnabled && this.grecaptcha) {
        try {
          recaptchaToken = await new Promise((resolve, reject) => {
            this.grecaptcha.ready(() => {
              this.grecaptcha
                .execute(
                  this.autoloadConfigValue(UI_CONFIGS.RECAPTCHA_SITE_KEY),
                  { action: "submit" }
                )
                .then(resolve)
                .catch(reject);
            });
          });
        } catch (error) {
          console.error("reCAPTCHA execution failed:", error);
        }
      }
      return recaptchaToken;
    },
    async reSendTwoFactor() {
      this.secondFactorNonce = generateNonce();

      let request = {
        nonce: this.secondFactorNonce,
        userId: this.userId,
        recaptchaToken: await this.executeRecaptcha(),
      };
      let response = await this.$store.dispatch(
        "session/resendTwoFactor",
        request
      );
      this.secondFactorId = response.secondFactorResponse.secondFactorId;
      this.timer = 29;
      this.startCountDown();
    },
    startCountDown() {
      let countDown = setInterval(() => {
        this.timer--;
        if (this.timer === 0) {
          clearInterval(countDown);
        }
      }, 1000);
    },

    async finishRegistration(registration) {
      await this.clearStore();
      await this.$store.dispatch("session/finishRegistration", registration);
      await this.$store.dispatch("profile/updateStatus", {
        status: "REGISTERED",
        result: "SUCCESS",
      });
      await this.fetchOnLogin();
    },
    async bypassTwoFactor(loginResponse) {
      await this.clearStore();

      let redirect = await this.$store.dispatch(
        "profile/setStatus",
        loginResponse
      );

      await this.fetchOnLogin();

      return redirect;
    },

    async finishLogin(solution) {
      await this.clearStore();

      let loginResponse = await this.$store.dispatch(
        "session/finishLogin",
        solution
      );
      let redirect = await this.$store.dispatch(
        "profile/setStatus",
        loginResponse
      );

      await this.fetchOnLogin();

      return redirect;
    },
    async finishPasswordChange(solution) {
      await this.clearStore();

      let chngResponse = await this.$store.dispatch(
        "session/finishPwdChange",
        solution
      );
      let redirect = await this.$store.dispatch(
        "profile/setStatus",
        chngResponse
      );

      await this.fetchOnLogin();

      return redirect;
    },
    async fetchOnLogin() {
      await this.$store.dispatch("myTodo/fetchCount");
      await this.$store.dispatch("purchase/hasActivePurchase");
    },
    async clearStore() {
      await this.$store.dispatch("myTodo/clear");
      await this.$store.dispatch("purchase/clear");
    },
  },
};
